module.exports = __webpack_public_path__ + "img/icono_2factura.53395c6a.svg";